// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3p7N0","signatureButtonsRight":"ModalSign_signatureButtonsRight__GvWV0"};